import Image from 'next/image';
import { IInstagramPost, IInstagramSection } from '@/interfaces/homepage';
import { InstagramPost } from './InstagramPost';
import { twMerge } from 'tailwind-merge';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';

interface Props {
  content: IInstagramSection;
}

interface InstagramGridProps {
  items: IInstagramPost[];
  isLarge?: boolean;
}

export function InstagramSection({ content }: Readonly<Props>) {
  if (!content?.Items?.length) {
    return <></>;
  }

  const mobileRows =
    content.Items.length <= 3
      ? { firstRow: [content.Items], secondRow: [] }
      : {
          firstRow: [content.Items.slice(0, Math.ceil(content.Items.length / 2))],
          secondRow: [content.Items.slice(Math.ceil(content.Items.length / 2))],
        };

  return (
    <section className="container" data-testid="instagram-section">
      {/* Header */}
      <div className="mb-8 flex flex-col items-center justify-center gap-3 lg:flex-row lg:justify-start">
        <div className="relative h-14 w-14">
          <Image src="/images/Instagram.png" alt="Instagram" fill quality={100} priority />
        </div>

        <h2 className="text-center text-2xl font-bold lg:text-4xl">{content.Title}</h2>
      </div>

      {/* Desktop */}
      <div className="max-lg:hidden">
        <InstragramGrid isLarge items={content.Items} />
      </div>
      {/* Mobile */}
      <div className="lg:hidden">
        {mobileRows.firstRow.map((row, index) => (
          <InstragramGrid key={index} items={row} />
        ))}
        {mobileRows.secondRow.map((row, index) => (
          <InstragramGrid key={index} items={row} />
        ))}
      </div>
    </section>
  );
}

const InstragramGrid = ({ items, isLarge }: InstagramGridProps) => {
  return (
    <div
      className={twMerge(
        isLarge ? 'grid grid-cols-5 gap-4' : 'flex overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
      )}
    >
      {items.map((post) => (
        <div key={post.ImageUrl} className={twMerge(!isLarge && 'w-1/2 flex-shrink-0')}>
          <InstagramPost post={post} />
        </div>
      ))}
    </div>
  );
};
